<template>
  <div>
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item>
          <a-input placeholder="活动名称" v-model="search.name" allowClear />
        </a-form-item>
        <a-form-item>
          <a-select
            style="width: 156px"
            v-model="search.type"
            placeholder="请选择项目类型"
            allowClear
          >
            <a-select-option v-for="item in subList" :key="item.id">
              {{ item.nickname }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="wrapperCol">
          <a-button @click="searchList"> 搜索</a-button>
        </a-form-item>

        <a-form-item :wrapper-col="wrapperCol">
          <a-tooltip title="重置搜索条件,刷新">
            <a-button @click="redo"> 重置条件 </a-button>
          </a-tooltip>
        </a-form-item>
      </a-form>
    </div>
    <div class="vd-gl-content">
      <a-row type="flex" class="vd-table-head">
        <a-col flex="auto" class="vd-table-name"> 小程序列表</a-col>
        <a-col class="vd-table-tool">
          <a-button
            v-if="$AuthUtil.authRoute('/program/add')"
            type="primary"
            icon="plus"
            @click="add"
          >
            新建
          </a-button>
          <a-divider type="vertical" />
          <a-icon class="common-icon" type="reload"></a-icon>
        </a-col>
      </a-row>
      <a-table
        :pagination="pagination"
        row-key="id"
        size="small"
        :dataSource="list"
        :loading="loading"
      >
        <a-table-column title="ID" data-index="id" />
        <a-table-column title="小程序名称" data-index="name" />
        <a-table-column title="项目" data-index="c_name" />
        <a-table-column title="备注" data-index="remark" :ellipsis="true" />
        <a-table-column title="最近修改时间" data-index="upd_time">
          <template slot-scope="times">
            {{ $FormatUtil.timestamp2date(times, 'YYYY-MM-DD') }}
          </template>
        </a-table-column>
        <a-table-column title="操作" align="center">
          <template slot-scope="record">
            <template v-if="$AuthUtil.authRoute('/program/edit')">
              <a-tooltip title="设置">
                <a-icon
                  class="common-icon"
                  type="setting"
                  @click="modify(record)"
                />
              </a-tooltip>
            </template>
            <a-tooltip title="详情">
              <a-icon
                class="common-icon"
                type="small-dash"
                @click="detail(record)"
              />
            </a-tooltip>
          </template>
        </a-table-column>
      </a-table>

      <a-modal
        v-model="visible"
        :title="modalType ? '修改小程序' : '添加小程序'"
        ok-text="确认"
        cancel-text="取消"
        @ok="Confirm"
        @cancel="cancel"
        :confirm-loading="confirmLoading"
      >
        <a-form-model
          ref="ruleForm"
          layout="horizontal"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="所属项目" prop="type">
            <a-select
              style="width: 156px"
              v-model="form.type"
              placeholder="请选择项目类型"
            >
              <a-select-option v-for="item in subList" :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="推广状态" prop="status">
            <a-radio-group v-model="form.status">
              <a-radio :value="0">推广结束</a-radio>
              <a-radio :value="1">推广中</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="小程序名" ref="name" prop="name">
            <a-input
              class="vd-input-s"
              v-model="form.name"
              placeholder="小程序名称"
            />
            <span class="common-mute"> {{ form.name.length }}/25</span>
          </a-form-model-item>
          <a-form-model-item label="AppID" prop="appId">
            <a-input
              class="vd-input-s"
              v-model="form.appId"
              placeholder="小程序唯一凭证"
            />
          </a-form-model-item>
          <a-form-model-item label="SecretID" prop="appSecret">
            <a-input
              class="vd-input-m"
              v-model="form.appSecret"
              placeholder="小程序唯一凭证密钥"
            />
          </a-form-model-item>
          <a-form-model-item label="Flag" prop="flag">
            <a-input
              class="vd-input-m"
              v-model="form.flag"
              placeholder="微信标识码"
            />
          </a-form-model-item>
          <a-form-model-item label="CRM 表单Sid" prop="sid">
            <a-input
              class="vd-input-m"
              v-model="form.sid"
              placeholder="活动表单的推送sid"
            />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark">
            <a-textarea
              class="vd-input-s"
              v-model="form.remark"
              placeholder="备注,字符限制100"
              :rows="3"
            ></a-textarea>
            <span class="common-mute"> {{ form.remark.length }}/60</span>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import { list, modify } from '@/api/program'
// 静态图片使用要引入

export default {
  name: 'Setting',
  data() {
    return {
      // modal
      loading: false,
      visible: false,
      modalType: false,
      confirmLoading: false,
      subList: [],
      // form
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      search: {
        name: undefined,
        type: undefined,
      },
      form: {
        id: 0,
        type: undefined,
        status: undefined,
        name: '',
        appId: '',
        appSecret: '',
        flag: '',
        sid: '',
        remark: '',
      },
      // rules
      rules: {
        name: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' },
          { min: 3, max: 25, message: '小程序名称长度3-25', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择小程序所属项目', trigger: 'blur' },
        ],
        status: [{ required: true, message: '推广状态', trigger: 'change' }],
        appId: [
          { required: true, message: '请输入小程序appId', trigger: 'blur' },
        ],
        appSecret: [
          {
            required: true,
            message: '请输入小程序secretId',
            trigger: 'change',
          },
        ],
        remark: [
          {
            min: 0,
            max: 60,
            message: '备注长度不要超过60个字符',
            trigger: 'change',
          },
        ],
      },
      // data
      list: [],
      // page
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        hideOnSinglePage: true,
        showTotal: (total) => `总共 ${total} 条`,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  created() {
    this.getData()
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      } else {
        this.$message.warning(res.msg)
      }
    })
  },
  methods: {
    /* 添加小程序 */
    add() {
      this.modalType = false
      this.form.id = undefined
      this.visible = !this.visible
    },
    searchList() {
      this.pagination.current = 1
      this.getData()
    },
    redo() {
      this.pagination.current = 1
      this.search.name = undefined
      this.search.type = undefined
      this.getData()
    },
    modify(record) {
      this.modalType = true
      this.visible = !this.visible
      this.confirmLoading = false
      this.form.id = record.id
      this.form.type = record.type === 0 ? undefined : record.type
      this.form.status = record.status
      this.form.name = record.name
      this.form.appId = record.app_id
      this.form.appSecret = record.secret_id
      this.form.flag = record.flag
      this.form.sid = record.sid
      this.form.remark = record.remark
    },
    detail(item) {
      // 默认跳入统计页面
      this.$router.push({ path: '/program/detail', query: { id: item.id } })
    },
    // modal
    Confirm() {
      this.confirmLoading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          modify(this.form).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
              this.confirmLoading = this.visible = false
              this.cancel()
              this.getData()
            } else {
              this.$message.warning(res.msg)
              setTimeout(() => {
                this.confirmLoading = false
              }, 2000)
            }
          })
        } else {
          setTimeout(() => {
            this.confirmLoading = false
          }, 2000)
          return false
        }
      })
    },
    cancel() {
      this.$refs.ruleForm.clearValidate()
      this.form.id = this.form.type = this.form.status = undefined
      this.form.name = this.form.appId = this.form.appSecret = this.form.remark = this.form.sid =
        ''
    },
    getData() {
      list({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.search.name,
        type: this.search.type,
      }).then((res) => {
        if (res.code === 1) {
          this.pagination.total = res.total
          this.list = res.list
        } else {
          this.pagination.total = 0
          this.list = []
        }
      })
    },
  },
}
</script>

<style scoped>
.tool {
  margin-bottom: 16px;
}
</style>
